<p-toast position="{{smallScreen ? 'bottom-right' : 'top-right'}}"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false">

  <p style="color:white" >Loading accounts... </p>
</ngx-spinner>

<div style="height:100%;display:flex;flex-direction:column;min-height:0;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadData()"></button>
                
        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add New User" 
                  icon="pi-fw fas fa-user-plus"
                  (click)="addAccount()"></button>

          <button pButton type="button" 
                  class="p-button p-button-text p-button-danger" 
                  label="Reset Password" 
                  icon="pi-fw fas fa-user-lock"
                  [disabled]="selectedRow === null"
                  (click)="resetPassword(selectedRow)"></button>

          <button pButton type="button" 
                  class="p-button p-button-text p-button-danger" 
                  label="Delete Account" 
                  icon="pi-fw fas fa-trash-alt"
                  [disabled]="selectedRow === null"
                  (click)="deleteAccount(selectedRow)"></button>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user-plus"
                  (click)="addAccount()"></button>

          <button pButton type="button" 
                  class="p-button-rounded p-button-danger" 
                  icon="pi-fw fas fa-user-lock"
                  [disabled]="selectedRow === null"
                  (click)="resetPassword(selectedRow)"></button>

          <button pButton type="button" 
                  class="p-button-rounded p-button-danger" 
                  icon="pi-fw fas fa-trash-alt"
                  [disabled]="selectedRow === null"
                  (click)="deleteAccount(selectedRow)"></button>
        </span>

      </span>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         severity="info"
         pTooltip="Total number of accounts: {{accounts.length}}"
         value="{{accounts.length}}"></i>
    </div>
  </p-toolbar>

  <div style="flex:1 1 auto;min-height:0;">
    <ag-grid-angular
        *ngIf="accounts.length > 0"
        style="width: 100%; height:100%;"
        class="ag-theme-alpine"
        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
        [gridOptions]="gridOptions"
        [context]="context"
        [rowData]="accounts"
        [columnDefs]="gridHeaders"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"></ag-grid-angular>
  </div>
</div>
